export const GetRoutesTest = () => {
    const datas = [
        { name: 'Routes Entities', route: '/admin/test/routes/entities' },
        { name: 'Routes NoSQL', route: '/admin/test/routes/nosql' }
    ];
    return datas;
}